import { Container, Graphics, Sprite } from 'pixi.js';
import { settingLabelStyle } from './fileStyle';
import { getAsset, onAssetsLoad } from 'game/preloadGameAssets';
import { TranslationText } from './TranslationText';

export class SwitchToggle {
    public container: Container;
    public label: TranslationText;
    public switch: Container;
    public isToggled: boolean;
    underline: Graphics;
    interactiveButton: Graphics;
    onChange: (checked: boolean) => void;
    constructor(labelKey: string, isToggled: boolean, cb: (checked: boolean) => void) {
        this.onChange = cb;
        this.toggle = this.toggle.bind(this);

        this.container = new Container();
        this.switch = new Container();
        this.underline = new Graphics();
        this.interactiveButton = new Graphics();
        this.container.zIndex = 2000;
        this.isToggled = isToggled;
        this.label = new TranslationText(labelKey, settingLabelStyle);
        this.label.text.position.y = -4;
        this.container.addChild(this.label.text);
        onAssetsLoad(this.drawSwitch.bind(this));
        this.container.addChild(this.switch);
        this.interactiveButton.eventMode = 'static';
        this.interactiveButton.cursor = 'pointer';
        this.container.addChild(this.interactiveButton);
        this.interactiveButton.on('pointerdown', this.toggle);
        this.addUnderline();
    }
    addUnderline() {
        this.container.addChild(this.underline);
        this.underline.visible = false;
        this.underline.rect(0, 35, 328, 1);
        this.underline.fill('#FFFFFF');
        this.underline.alpha = 0.3;
    }
    showUnderline(visible: boolean) {
        this.underline.visible = visible;
    }

    toggle() {
        this.isToggled = !this.isToggled;
        this.drawSwitch();
        this.onChange(this.isToggled);
    }
    public async drawSwitch() {
        this.switch.removeChildren();
        const buttonState = await getAsset(this.isToggled ? 'settings/itsOn' : 'settings/itsOff');
        const iconSprite = Sprite.from(buttonState);
        iconSprite.anchor.set(0.5);
        iconSprite.width = 60;
        iconSprite.height = 32;
        this.switch.addChild(iconSprite);
        this.interactiveButton.clear();
        this.interactiveButton.roundRect(266, -15, 70, 40, 30);
        this.interactiveButton.fill(0xffffff);
        this.interactiveButton.alpha = 0.000001;
    }
}
